import { render, staticRenderFns } from "./PdfView.vue?vue&type=template&id=59666ef5&scoped=true"
import script from "./PdfView.vue?vue&type=script&lang=js"
export * from "./PdfView.vue?vue&type=script&lang=js"
import style0 from "./PdfView.vue?vue&type=style&index=0&id=59666ef5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59666ef5",
  null
  
)

export default component.exports